module.exports = __webpack_public_path__ + "img/clint7.f2bc1fb4.png";